/* eslint-disable */
import React from 'react';
import {
    Datagrid,
    TextField,
    List,
    Filter,
    TextInput,
    ReferenceField,
    useRecordContext,
    Labeled
} from 'react-admin';
import { ReadOnlyContext } from '../../lib/context/ReadOnlyContext';
import { SwList } from '../../lib/SwList';
import { useAzureADGroups } from '../../msal/useAzureADGroups';
import { CourseDeliveryField } from '../CourseInstance/CourseInstanceShow';

const CourseCodeSelector = ({ isAssociateCourse }) => {
    if (isAssociateCourse) {
        return (
            <ReferenceInput reference="AssociateCourse" source="courseCode">
                <AutocompleteInput
                    optionText="Title"
                    label="Associate Course"
                />
            </ReferenceInput>
        );
    }

    return (
        <>
            <ReferenceInput reference="Course" source="courseCode">
                <AutocompleteInput optionText="Title" label="Course" />
            </ReferenceInput>
        </>
    );
};

const ParentCourseShow = () => {
    const { isAssociateCourse } = useRecordContext();
    const courseReference = isAssociateCourse ? 'AssociateCourse' : 'Course';

    const courseSource = isAssociateCourse
        ? 'associateCourseCode'
        : 'courseId';


    return (
        <>            
            <div>
                <Labeled>
                    <ReferenceField
                        label={false}
                        reference={courseReference}
                        source="courseCode"
                        link="edit"
                    >
                        <TextField source='id'/>
                        &nbsp; - &nbsp; 
                        <TextField source="Title" />
                    </ReferenceField>
                </Labeled>
            </div>
        </>
    );
};

const CourseInstanceList = (props) => {
    const { canEditCourseAndModule } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditCourseAndModule}>
            <SwList
                {...props}
                filters={<CourseInstanceFilter />}
                title="Course Instances">
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditCourseAndModule ? false : undefined}>
                    <TextField source="id" />
                    <TextField source="quercusCode" />
                    <CourseDeliveryField {...props} label="Course Delivery Description"/>
                    <TextField source="courseYear"/>
                    <ParentCourseShow label="Parent Course" />  
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const CourseInstanceFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <TextInput source="id" />
        <TextInput source="courseId" />
        <TextInput source="courseDelivery" />
        <TextInput source="quercusCode" />
    </Filter>
);

export default CourseInstanceList;
